import indexController from "./indexController";
import articleController from "./articleController";
import searchController from "./searchController";
import groupIndexController from "./groupIndexController";
import groupUserController from "./groupUserController";
import groupViewController from "./groupViewController";
import articleCreatController from "./articleCreatController";
import articleUpdateController from "./articleUpdateController";
import joinController from "./joinController";

export default {
    indexController: indexController,
    articleController: articleController,
    searchController: searchController,
    groupIndexController: groupIndexController,
    groupUserController: groupUserController,
    groupViewController: groupViewController,
    articleCreatController: articleCreatController,
    articleUpdateController: articleUpdateController,
    joinController: joinController
};
